import { BpButton } from '../../../../shared/components/buttons/bp-button/BpButton'

/** Плашка реферальной программы: пока отключена через !hidden */
export const ReferralBanner = () => {
  return (
    <div className={'flex !hidden h-[48px] w-full items-center bg-focus-600'}>
      <div className={'flex w-full items-center justify-center gap-[16px] pl-[48px]'}>
        <p className={'text-[20px] leading-[32px] text-white'}>
          You earned <span className={'text-[#FBFF3B]'}></span> by referral program
        </p>
        <div>
          <BpButton contentClassName={'font-normal'} size={'sm'}>
            Withdraw earnings
          </BpButton>
        </div>
      </div>
      <div className={'w-[48px] p-[12px]'}>x</div>
    </div>
  )
}
